// 低版本兼容
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueHammer } from 'vue2-hammer'

// --------- style
import './styles/normalize.css'
import './assets/css/common.less'
import './styles/normalize.css'
import '@bilibili/fe-quick-share/dist/share.css'
import '@bilibili/fe-quick-share/dist/bar.css'
// --------- extends register
// import './register'
// --------- component
import './global.css'
Vue.config.productionTip = false
Vue.use(VueHammer)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
